/** @file requireSectorTable: a sector table by id, the puppet's own tables first, then the built-ins. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import type { SectorTable } from '@zilo/pose3d-format/types/facet';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import { throwError } from '@zilo/pose3d-std/errors/throwError';

/** `puppet.sectorTables[id] ?? builtins[id]`; `SECTOR_TABLE_UNKNOWN` at `path` otherwise. */
export function requireSectorTable(puppet: Pick<Puppet, 'sectorTables'>, id: string, builtins: Readonly<Record<string, SectorTable>>, path = '/input/table'): SectorTable {
  const table = puppet.sectorTables?.[id] ?? builtins[id];
  if (table !== undefined) return table;
  return throwError(ERROR_CODES.SECTOR_TABLE_UNKNOWN, { table: id }, { path, hint: 'a built-in table id (MIRROR_16, FACE_8, ...) or a table object' });
}
